import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=58b69a62&scoped=true&"
import script from "./employee.vue?vue&type=script&lang=js&"
export * from "./employee.vue?vue&type=script&lang=js&"
import style0 from "./employee.vue?vue&type=style&index=0&id=58b69a62&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b69a62",
  null
  
)

export default component.exports